<template>
  <div class="showItemDiv" v-show="showListData.length>0">
    <div v-for="(item, index) in showListData" :key="index">
      <div class="showNewsItem" @click="jumpNext(item)">
        <p class="leftPoint" v-show="isShowPoint"></p>
        <p class="showNewsContent pStyle">{{ item.name }}</p>
        <p class="showTimeP pStyle">{{ item.time && item.time.substring(0, item.time.lastIndexOf(" "))}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showListData: [],
    isShowPoint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    jumpNext(item) {
      if (item.openStyle === '1' && item.extLinkUrl) {
        window.open(item.extLinkUrl)
      } else {
        this.$emit("onNewsItemClick", item);
      }
    },
  },
};
</script>


<style lang="less" scoped>
.showItemDiv {
  width: 100%;
  height: auto;

  .showNewsItem {
    display: flex;
    width: 100%;
    height: 40px;
    position: relative;
    align-items: center;
    cursor: pointer;

    .leftPoint {
      width: 4px;
      height: 4px;
      background: #c03429;
      border-radius: 1px;
      flex: 0 0 auto;
    }

    .showNewsContent {
      width: 100%;
      margin-left: 5px;
      margin: 0 5px ;
      color: #333333;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 24px;
    }

    .showTimeP {
      width: 100px;
      font-size: 14px;
      color: #999999;
      flex: 0 0 auto;
      line-height: 24px;
    }
  }

  .showNewsItem:hover {
    background: #f0f0f0;
  }
}
.pStyle {
  font-family: PingFang SC;
  font-weight: 400;
}
</style>